import { GlobalAxios } from "../axios/axios-config";
import { ITicketAutomationReceivedRulePriceInsurance } from "../models/ticket-automation-received-rule-price-insurance";

const TICKET_AUTOMATION_RECEIVED_RULE_PRICE_INSURANCE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedRulePriceInsurance/";

export const createTicketAutomationReceivedRulePriceInsurance = (
  item: ITicketAutomationReceivedRulePriceInsurance,
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_RULE_PRICE_INSURANCE_ROUTE,
    item,
  );
};

export const getTicketAutomationReceivedRulePriceInsuranceById = (
  id: string,
) => {
  return GlobalAxios.get<ITicketAutomationReceivedRulePriceInsurance>(
    TICKET_AUTOMATION_RECEIVED_RULE_PRICE_INSURANCE_ROUTE + id,
  );
};

export const updateTicketAutomationReceivedRulePriceInsuranceById = ({
  item,
  id,
}: {
  item: ITicketAutomationReceivedRulePriceInsurance;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_RULE_PRICE_INSURANCE_ROUTE + id,
    item,
  );
};
